import { useMainSelector } from '../../useMainSelector';

export const useFlow = () => {
  const {
    designer: {
      selectedBlock,
      targetBlock,
      flowDirection,
      blocksSearchString,
      blocksSearchMatchIndex,
      flow: { selectedSubFlow, subFlows },
    },
  } = useMainSelector();

  return {
    selectedSubFlow,
    subFlows,
    targetBlock,
    selectedBlock,
    flowDirection,
    flowSearchQuery: blocksSearchString,
    flowMatchIndex: blocksSearchMatchIndex,
  };
};
